import React from 'react';
import { Box, Button, Heading, Text } from '@wix/design-system';
import { useTranslation } from '@wix/wix-i18n-config';
import { useAtomValue } from 'jotai';
import { isThemeLoadingAtom } from '../atoms';
import { useSelectedThemeColor } from '../../../store/appStore';
import { CardLayout } from '../../../components/layouts';
import { Check, ChevronRight } from '@wix/wix-ui-icons-common';
import { Dot } from '../../../components/Dot';
import { THEME_KEYS_TRANSLATIONS } from '@common/constants/themes';
import { useTemplateNavigation } from '../hooks/useTemplateNavigation';
import s from './TemplateSideContent.scss';
import { templateColors } from '../types';

export function TemplateSideContent() {
  const { t } = useTranslation();
  const selectedThemeColor = useSelectedThemeColor();
  const isLoading = useAtomValue(isThemeLoadingAtom);
  const { handleNext } = useTemplateNavigation();
  const selectedTheme = templateColors.find((theme) => theme.name === selectedThemeColor);

  if (!selectedTheme) {
    return null;
  }

  return (
    <CardLayout>
      <Box direction="vertical" gap={4}>
        <Box direction="vertical" gap={1}>
          <Heading size="small">{t('template_select.side_content.header')}</Heading>

          <Text>
            {t('template_select.side_content.subtitle', { theme: THEME_KEYS_TRANSLATIONS[selectedTheme.name] })}
          </Text>
        </Box>

        <Box direction="vertical" gap={2}>
          <Box verticalAlign="middle" gap={2}>
            <Dot />
            <Text weight="bold">{t('CURRENT_SELECTION')}</Text>
          </Box>

          <div className={s.themePreview}>
            <Box className={s.checkmarkContainer}>
              <Check />
            </Box>
            <Box direction="vertical" gap="3px">
              <Text weight="bold" size="medium">
                {THEME_KEYS_TRANSLATIONS[selectedTheme.name]}
              </Text>

              <Text size="small" secondary>
                {selectedTheme.description}
              </Text>
            </Box>
            <Box className={s.colorDots}>
              {selectedTheme.colors.map((color, i) => (
                <Box key={i} className={s.colorDot} style={{ backgroundColor: color }} />
              ))}
            </Box>
          </div>
        </Box>

        <Button
          size="large"
          onClick={handleNext}
          disabled={isLoading || !selectedThemeColor}
          suffixIcon={<ChevronRight />}
        >
          {t('template_select.side_content.cta')}
        </Button>
      </Box>
    </CardLayout>
  );
}
